import type { AxiosError } from "axios";

import { logoutAdmin } from "~/admins/api";
import { ROUTES } from "~/admins/router";

export const errorInterceptor = async (error: AxiosError) => {
  if (error?.response?.status === 401) {
    await logoutAdmin();
    window.location.href = ROUTES.login;
  }

  if (error?.response?.status === 404) {
    window.location.href = ROUTES.notFound;
  }

  if (error?.response?.status === 500) {
    window.location.href = ROUTES.internalError;
  }
  return Promise.reject(error);
};
